import * as React from "react"
import T from "../T/T";
import "./styles.scss";
import ClaimRewardBtn from "../ClaimRewardBtn";

export default function DwaOffers({ type, offers, showReward, imageHeight, titleBold = false }) {
    const isRewards = type === "rewards";
    return (
        <div className={`block offer ${showReward ? 'claim' : ''}`}>
            <div className="block-content">
                <div className={`uk-slider-container-offset di-slider`}
                    uk-slider="true"
                    style={{ position: "relative" }}
                >
                    { isRewards && <div className="check-email"><T>check-email</T></div> }
                    { isRewards && <div className="check-email-message"><T>check-email-message</T></div> }
                    <div className="uk-position-relative uk-visible-toggle uk-light" tabIndex="-1">
                        <ul className={`uk-slider-items uk-grid ${type === 'gifts' ? 'gift' : ''}`}>
                            {offers?.map((item, index) => {
                                const imagePath = type === 'gifts' ? item.imagePath : item.reward_image_url;
                                const title = type === 'gifts' ? <T>{item.title}</T> : item.reward_title;
                                const description = type === 'gifts' ? <T>{item.description}</T> : item.reward_terms;

                                return (
                                    <li key={index} className={`${offers?.length === 1 ? 'offer' : ''}`}>
                                        <div className={`uk-card uk-card-default`}>
                                            <div className="uk-card-media-top">
                                                <img src={imagePath} alt="" style={{ height: imageHeight }} />
                                            </div>
                                            <div className="uk-card-body">
                                                <p className={`title ${titleBold && 'title-bold'}`}>{title}</p>
                                                <p className="description">{description}</p>
                                            </div>
                                        </div>
                                    </li>
                                )
                            }
                            )}
                        </ul>
                    </div>
                </div>

                {!!showReward &&
                    <ClaimRewardBtn text={'Product Passport'} to={'/dwa'}/>
                }
            </div>
        </div>
    )
}
